import useOrganisationSettings from 'components/hooks/useOrganisationSettings';
import { useLocation } from 'react-router-dom';

import { OKR_TYPES } from 'constants/ProjectConstants';
import { StringModifier, modifyString } from 'constants/copyHelpers';
import { getObjectiveDetailsRoute, getTaskDetailsRoute } from 'constants/helper';

import { useCopyToClipboard } from './useCopyToClipboard';

/* currently only works when bottom drawer is open */
export const useShareOKRLogic = ({ uuid, type }) => {
  const { moduleName, objectivesName, keyResultsName } = useOrganisationSettings();
  const location = useLocation();

  const isObjective = type === OKR_TYPES.OBJECTIVE;
  const isInitiative = type === 'TASK';

  let successMessage = `The URL to share this ${
    isObjective
      ? modifyString(objectivesName, StringModifier.SENTENCE_CASE)
      : modifyString(keyResultsName, StringModifier.SENTENCE_CASE)
  } has been successfully copied to clipboard.`;

  if (isInitiative) successMessage = `The URL to share this initiative has been successfully copied to clipboard.`;

  const getObjectiveRoute = () =>
    getObjectiveDetailsRoute({
      location,
      objectivePId: uuid,
      useCurrentRoute: false,
    });

  const getTaskRoute = () =>
    getTaskDetailsRoute({
      location,
      ids: [uuid],
      useCurrentRoute: false,
      type,
    });

  const url = `${window.location.origin}/app${isObjective ? getObjectiveRoute() : getTaskRoute()}`;

  const copyToClipboard = useCopyToClipboard({
    text: url,
    successfulMessage: successMessage,
    failureMessage: `The URL to share could not be copied to clipboard`,
  });

  return {
    copyToClipboard,
  };
};
